import React from 'react'

const Door = () => {
    return (
        <div className="door">
            <h3 className="door-header">
                Door to Door
            </h3>
            <p>
                With point to point service delivery we are at the forefront on Southern Sudan reconstruction and delivery of 
                relief services to the Horn of Africa/Great lakes Region; 
                Namely-Kenya, Uganda, Tanzania, Somalia, Ethiopia, Burundi, Rwanda, Democratic Republic of Congo and Sudan.
            </p>
        </div>
    )
}

export default Door
